export default "__VITE_ASSET__02bc875b__"